import { Exception } from "./Exception";
import { ErrorSeverity } from "./ErrorSeverity";

export class NotAcceptableException extends Exception {
  constructor({ message, response, stack }: { message: string; response: Response; stack?: string }) {
    super({
      errorSeverity: ErrorSeverity.ERROR,
      useErrorBoundary: false,
      name: "NotAcceptableException",
      message,
      response,
      stack,
    });
  }
}
